import './App.css';
import MarkdownPreviewer from './MarkdownPreviewer';

function App() {
  return (
    <div className="App">
      <MarkdownPreviewer />
    </div>
  );
}

export default App;
